import React, {Component} from "react";
import {UncontrolledTooltip} from "reactstrap";
import Datetime from "react-datetime";
import moment from "moment";
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";

class EBelgeIadePane extends Component{
    constructor(props) {
        super(props);
        this.state ={
            error:{},
            iadeTables:[]
        };
        this.addIadeTable 		= this.addIadeTable.bind(this);
        this.removeIadeTable 	= this.removeIadeTable.bind(this);
        this.onChange 		= this.onChange.bind(this);
        this.validateField  = this.validateField.bind(this);
    }

    componentWillMount() {
        let iadeTables = this.props.iadeTables;
        this.setState({iadeTables});
    }

    onChange(e,index){
        let iadeTables = deepCopyObject(this.state.iadeTables);
        iadeTables[index][e.target.name]= e.target.value;
        this.props.listenerIadeTable(iadeTables);
        this.setState({iadeTables});
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
        this.props.errorListener(error);
    }

    addIadeTable(e){
        let iadeTables = deepCopyObject(this.state.iadeTables);
        iadeTables.push({recordId:null,referenceId:'', referenceIssueDate:''});
        this.props.listenerIadeTable(iadeTables);
        this.setState({iadeTables});
    }

    removeIadeTable(e,index){
        let iadeTables = deepCopyObject(this.state.iadeTables);
        iadeTables.splice(index, 1);
        this.props.listenerIadeTable(iadeTables);
        this.setState({iadeTables});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    componentWillReceiveProps(nextProps){
        if(this.props.error !== nextProps.error){
            this.setState({error:nextProps.error});
        }

        if (nextProps.manual) {
            this.setState({iadeTables: nextProps.iadeTables,error:{}});
            this.props.isManual(false);
            this.props.errorListener({});
        }
    }

    render(){
        return (
            <div className="col-sm-12">
                <table style={{textAlign: 'center'}}>
                    <thead>
                    <tr style={{backgroundColor: '#ebedf0'}}>
                        <th width="20%" >Fatura No</th>
                        <th width="25%">Düzenlenme Tarihi</th>
                        <th width="10%">İşlemler</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.state.iadeTables.map((iade, index) =>
                            <tr key={index}>
                                {this.props.documentTypeCode === "IADE" &&
                                <td className={"form-group" + this.validateClass('faturaNo_' + index)}>
                                    <input className="form-control"
                                           id={"faturaNo_" + index}
                                           name="faturaNo"
                                           type="text"
                                           data-vlength={"0,16"}
                                           onBlur={this.validateField}
                                           value={iade.faturaNo || ""}
                                           onChange={(e) => this.onChange(e, index)}/>
                                    {this.validateMessage("faturaNo_" + index) !== "" &&
                                    <UncontrolledTooltip placement="right" target={"faturaNo_" + index} delay={0}>
                                        {this.validateMessage("faturaNo_" + index)}
                                    </UncontrolledTooltip>}
                                </td>}
                                {this.props.documentTypeCode === "IADE" &&
                                <td className={"form-group" + this.validateClass('duzenlenmeTarihi_' + index)}>
                                    <Datetime locale="tr"
                                              className="datepicker"
                                              input={true}
                                              inputProps={{id: "duzenlenmeTarihi_" + index}}
                                              onBlur={(momentObj) => this.validateField({
                                                  target: {
                                                      id: "duzenlenmeTarihi_" + index,
                                                      dataset: {
                                                          'vdata': "date",
                                                          'vlength': (iade.referenceId ? "1,255" : "0,255")
                                                      },
                                                      value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)
                                                  }
                                              })}
                                              closeOnSelect={true}
                                              value={moment(iade.duzenlenmeTarihi, "YYYY-MM-DD", true).isValid() ? moment(iade.duzenlenmeTarihi).format("DD-MM-YYYY") : iade.duzenlenmeTarihi}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={function (current) {
                                                  return current.isBefore(Datetime.moment());
                                              }}
                                              onChange={(momentObj) => this.onChange({
                                                  target: {
                                                      name: 'duzenlenmeTarihi',
                                                      value: (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)
                                                  }
                                              }, index)}/>
                                    {this.validateMessage("duzenlenmeTarihi_" + index) !== "" &&
                                    <UncontrolledTooltip placement="right" target={"duzenlenmeTarihi_" + index}
                                                         delay={0}>
                                        {this.validateMessage("duzenlenmeTarihi_" + index)}
                                    </UncontrolledTooltip>}
                                </td>}
                                {this.props.documentTypeCode === "IADE" &&
                                <td>
                                    {this.state.iadeTables.length !== 1 &&
                                    <button type="button" rel="tooltip"
                                            onClick={(e) => this.removeIadeTable(e, index)} data-placement="left"
                                            title="Satırı Sil" className="Btn temizle"
                                            style={{
                                                background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                                marginRight: '3px'
                                            }}>
                                    </button>
                                    }
                                    {this.state.iadeTables.length === index + 1 &&
                                    <button type="button" rel="tooltip" onClick={(e) => this.addIadeTable(e)}
                                            data-placement="left"
                                            title="Satır Ekle" className="Btn ekle">
                                    </button>
                                    }
                                </td>}
                            </tr>
                    )}
                    </tbody>
                </table>
            </div>
        );
    }
}
export default EBelgeIadePane;